import { render } from "./AppHeader.vue?vue&type=template&id=ed3a528a&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=ed3a528a&scoped=true&lang=css"

import exportComponent from "C:\\DEV\\Projects\\2025_ostrowskiortopeda_pl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3a528a"]])

export default __exports__